// extracted by mini-css-extract-plugin
module.exports = {"nav":"DealAndGoNavButtons_nav__13c8i","row":"DealAndGoNavButtons_row__2MptJ"};